import styled from "styled-components"

import Details from "Catalog/Edit/shared/components/Details"

export const AlcoholAndCaffeine = styled(Details.SplitHalf)`
  margin-top: 1.5rem;
`
